import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom';
import { ServerErrorBoundary } from 'shared/errors/ServerErrorBoundary';
import { LoadboardAccessContext } from 'shared/modules/loadboard/core/loadboard-access/LoadboardAccessContext';
import { LoadboardInsuranceExpiringDialog } from 'shared/modules/loadboard/core/loadboard-access/LoadboardInsuranceExpiringDialog';
import { basePath } from 'shared/utils/RouterUtils';
import { LoadboardContextProvider } from './data/LoadboardContext';
import { loadboardMobileRoutes } from './LoadboardMobileRoutes';

const LoadboardMobileLayout = () => {
  return (
    <ServerErrorBoundary subscribe={['CARRIER_CONNECTION_ERROR']}>
      <LoadboardContextProvider>
        <LoadboardAccessContext>
          <LoadboardInsuranceExpiringDialog />
          <Outlet />
        </LoadboardAccessContext>
      </LoadboardContextProvider>
    </ServerErrorBoundary>
  );
};

const loadboardRouter = createBrowserRouter(
  [{ element: <LoadboardMobileLayout />, children: loadboardMobileRoutes }],
  { basename: basePath },
);

export function LoadboardMobileRoutes() {
  return <RouterProvider router={loadboardRouter} />;
}
